<ng-container *transloco="let t">
  @if (fetchingConfirmation) {
    <app-page-template [showBreadcrumbs]="true" [showFooter]="false"></app-page-template>
  } @else {
    @if (!isPreviewComponent && !isManagement) {
      <app-page-template [showBreadcrumbs]="true" [showFooter]="!isPreviewComponent && !isManagement">
        <ng-template *ngTemplateOutlet="page"></ng-template>
      </app-page-template>
    } @else {
      <ng-template *ngTemplateOutlet="page"></ng-template>
    }
  }


  <ng-template #page>
    <div class="container pb-300-100">
      <div class="py-62-32">
        <app-breadcrumbs/>
      </div>
      <span class="fs-36-24 fw-medium">
        <app-language-output [hrLabel]="event?.name" [srLabel]="event?.nameSr" [enLabel]="event?.nameEng"
                             [itLabel]="event?.nameIta" [siLabel]="event?.nameSlo" [bsLabel]="event?.nameBs"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
        {{" - "}}
        <app-language-output [hrLabel]="race?.name" [srLabel]="race?.nameSr" [bsLabel]="race?.nameBs"
                             [enLabel]="race?.nameEng" [itLabel]="race?.nameIta" [siLabel]="race?.nameSlo"
                             [defaultLanguage]="event?.defaultLanguage" [languages]="languages"/>
      </span>
      <h2 class="fs-24-16">
        <div class="date-wrapper">
          <app-event-date-display [eventItem]="event"/>
        </div>
      </h2>
      <div class="pt-20-10">
        <div class="row">
          <div class="col-12 col-xxl-6 increase-column-right-spacing">
            <div class="row row-custom-padding">
              <div class="col-6">
                <button type="button"
                        class="registration-btn btn btn-primary square-button w-100 btn-left-align fw-semibold btn-no-tap"
                        (click)="goToRegistrationInfo()">
                  <img src="assets/icons/icons-alt/checkmark-square-03.svg" alt="Checkmark" class="pe-2">
                  <p class="medium">{{t('app.register.to.race.info')|uppercase}}</p>
                </button>
              </div>
              <div class="col-6">
                <button type="button"
                        class="registration-btn btn btn-primary square-button w-100 btn-left-align fw-medium fw-semibold btn-no-tap"
                        (click)="confirmRegistration()">
                  @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION
                  && event?.paymentSettings?.paymentType?.includes(EventPaymentType.PAYMENT_BY_BANK_TRANSFER)) {
                    <ng-container *ngIf="wspayConfirmation?.paymentStatus === WsPaymentStatus.ERROR; else successIcon">
                      <img src="assets/img/x.png" alt="Error" class="pe-2">
                    </ng-container>
                    <ng-template #successIcon>
                      <img src="assets/icons/icons-alt/checkmark-square-03.svg" alt="Success" class="pe-2">
                    </ng-template>
                  }
                  @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
                    <img src="assets/icons/icons-alt/checkmark-square-03.svg" alt="Checkmark" class="pe-2">
                  }
                  <p class="medium">{{t('app.register.to.race.confirmation')|uppercase}}</p>
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-xxl-6 increase-column-left-spacing"></div>
        </div>
        <div class="row pt-20-10">
          <div class="col-12 col-xxl-6 increase-column-right-spacing">
            @if (!authenticationService.isAuthenticated()) {
              <div class="pb-2">
                <a (click)="onRedirectToLogin()" class="text-decoration-underline color-teal-500">{{
                    t('app.common.login')
                  }}</a>
              </div>
            }
            @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO) {
              <ng-template *ngTemplateOutlet="registrationInfo"></ng-template>
            }
            @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION) {
              <ng-template *ngTemplateOutlet="confirmation"></ng-template>
            }
            @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
              <ng-template *ngTemplateOutlet="paymentStatus"></ng-template>
            }
          </div>
          <ng-template *ngTemplateOutlet="summary"></ng-template>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template #registrationInfo>
    @for (competitorRegistration of registrations;track $index) {
      <div #racerBlock></div>
      <div [class.pt-48-38]="$index > 0">
        <app-section-card [title]="(this.registrations[$index].firstName?.length ?? 0 > 0 ||
                      this.registrations[$index].lastName?.length ?? 0 > 0 ) ? (this.registrations[$index].firstName ??
                       '')
                      + ' ' + (this.registrations[$index].lastName ?? '') : t('app.register.to.race.participant')">
          @if (isRemoveNewRacerVisible($index)) {
            <ng-container slot="trailing-icon">
              <img src="assets/img/delete-icon.png" alt="{{t('app.register.to.race.removeRacer')}}"
                   class="pe-3 cursor-pointer" (click)="removeRacer()">
            </ng-container>
          }
          <app-register-to-race-item [event]="event" [race]="race" [index]="$index"
                                     [isAdmin]="isManagement"
                                     [competitorRegistration]="competitorRegistration"
                                     [isFirstRegistration]="$index === 0" [eventCommercialItems]="eventCommercialItems"
                                     [registerForMySelf]="$index === 0 ? registerForMySelf : false"
                                     [countries]="countries" [tshirtSizes]="tshirtSizes" [meals]="meals"
                                     [transports]="transports" [genders]="genders" [currencies]="currencies"
                                     [disciplines]="disciplines"
                                     [registerToRaceUserTypeState]="registerToRaceUserTypeState"
                                     [currentUserDetails]="currentUserDetails"
                                     [applicationFormSettings]="race?.applicationFormSettings"
                                     [raceCommercialItems]="raceCommercialItems"
                                     [raceAdditionalItems]="raceAdditionalItems" [registerHelper]="registerHelper"
                                     [isTeamRegistration]="registerHelper!.isTeamRegistration()" [languages]="languages"
                                     [emailRequired]="!isManagement || !organiserDataForm.controls['registrationPayed'].value"
                                     (changeRace)="onChangeRace($event)"
                                     (changeRegisterToRaceForMyself)="onChangeRegisterToRaceForMyself($event)"
                                     (onChangeFirstName)="registerHelper!.onChangeFirstName($event, $index)"
                                     (onChangeLastName)="registerHelper!.onChangeLastName($event, $index)"
                                     (onChangeRegistrationFeeId)="registerHelper!.onChangeRegistrationFeeId($event)"
                                     (onChangeEmail)="registerHelper!.onChangeEmail($event, $index)"
                                     (onChangeRaceAdditionalItems)="registerHelper!.onChangeRaceAdditionalItems($event, $index)"/>
        </app-section-card>
      </div>
    }
    @if (!hideTermsAndConditionsCheckbox) {
      <form [formGroup]="consentForm">
        <div class="col-12 pt-30-28 d-flex">
          <div (click)="openConsentModal()">
            <app-checkbox formControlName="termsAndConditionsAccepted" [hideErrorMessage]="false"/>
          </div>
          <span><a (click)="openConsentModal(true)"
                   [class.error]="!consentForm.controls.termsAndConditionsAccepted.valid && consentForm.controls.termsAndConditionsAccepted.touched">{{
              t('app.common.accept.conditions')
            }}</a></span>
        </div>
      </form>
    }

   @if (isManagement) {
      <form [formGroup]="organiserDataForm">
              <div class="col-12 pt-20-10">
              <app-checkbox formControlName="registrationPayed" label="app.register.to.race.registrationPayed" />
              </div>
      </form>
     }

    <div class="d-none d-xxl-flex pb-3">
      <ng-container *ngTemplateOutlet="racerButtonsTemplate"></ng-container>
    </div>
  </ng-template>

  <ng-template #confirmation>
    <div #confirmationBlock>
    <app-section-card [title]="t('app.register.to.race.confirmation.registration')" [enableToggle]="false"
                      [backgroundColor]="'var(--teal-50)'">
      <div class="teal-50-bg">
        <p class="medium">
          @if (registrationWithoutPayment || (raceCommercialItems?.length ?? 0) === 0 || getTotalPrice() === 0) {
            {{t('app.register.to.race.confirmation.well.done', {name: registrations[0].firstName})}}
          } @else {
            {{t('app.register.to.race.confirmation.dear.' + (registrations[0].gender || 1), {name:
            registrations[0].firstName})}}
          }
        </p>
        @if (registrationWithoutPayment || (raceCommercialItems?.length ?? 0) === 0 || getTotalPrice() === 0) {
          <h1>{{
              t('app.register.to.race.confirmation.you.are.now.registered')
            }} </h1>
        }
        @if (event?.paymentSettings?.mandatoryPayment !== true || (raceCommercialItems?.length ?? 0) === 0 || getTotalPrice() === 0) {
          <p class="pb-3 regulat">{{ t('app.register.to.race.confirmation.we.have.sent.you.an.email') }}</p>
        }
        @if ((raceCommercialItems?.length ?? 0) === 0 || getTotalPrice() === 0) {
          <div class="d-flex justify-content-end align-items-center">
            <ng-container *ngTemplateOutlet="closeButton"></ng-container>
          </div>
        }

          @if (event?.paymentSettings?.mandatoryPayment !== true && registerToRaceResponse?.endDateForPayment
          && !registrationWithoutPayment && getTotalPrice() !== 0) {
            <p class="pb-16 medium color-primary">{{
                t('app.register.to.race.confirmation.registration.is.valid.until', {
                  date: registerToRaceResponse!.endDateForPayment! |
                    date:
                    'dd.MM.yyyy HH:mm': undefined: translocoService.getActiveLang()
                })
              }} </p><p class="medium pb-4 color-primary">{{t('app.register.to.race.confirmation.please')}}{{
                t('app.register.to.race.confirmation.make.the.payment.by.the.specific.date')
              }}{{
                t('app.register.to.race.confirmation.in.order.to.be.able.to.participate.the.race')
              }} </p>
          }
          @if (event?.paymentSettings?.mandatoryPayment && !registrationWithoutPayment && ((raceCommercialItems?.length
            ?? 0) > 0) && getTotalPrice() !== 0) {
            <p class="medium pb-4 color-primary">
              {{
                t('app.register.to.race.confirmation.payment.needed')
              }} </p>
          }
          @if (!(event?.paymentSettings?.paymentType?.includes(EventPaymentType.ONLINE_PAYMENT) &&
            !registrationWithoutPayment) && ((raceCommercialItems?.length
            ?? 0) > 0) && getTotalPrice() !== 0) {
            <div class="d-flex justify-content-end align-items-center">
              <ng-container *ngTemplateOutlet="closeButton"></ng-container>
            </div>
          }
        </div>
        @if ((raceCommercialItems?.length
          ?? 0) > 0 && getTotalPrice() !== 0) {
          @if (event?.paymentSettings?.mandatoryPayment !== true && event?.paymentSettings?.paymentType?.includes(
            EventPaymentType.PAYMENT_BY_BANK_TRANSFER) && !registrationWithoutPayment) {
            <div class="pt-3">
              <p class="medium">{{t('app.register.to.race.confirmation.payment.info')}}</p>
              <p class="regular">{{
                  t('app.register.to.race.confirmation.payment.is.made.to',
                    {
                      organiser: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.name
                        ?? '',
                      city: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.city ??
                        '',
                      country: registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payee?.country ??
                        ''
                    })
                }} </p>
              <p class="regular">{{
                  t('app.register.to.race.confirmation.payment.bank.account', {
                    bankAccount:
                      registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeIban ?? ''
                  })
                }} </p>
              <p class="regular">{{
                  t('app.register.to.race.confirmation.payment.reference', {
                    payeeReferenceNumber:
                      registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeReferenceNumber ?? ''
                  })
                }} </p>
              <p class="regular">{{
                  t('app.register.to.race.confirmation.payment.description', {
                    paymentDescription:
                      registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.paymentDescription ?? ''
                  })
                }} </p>
              <p class="regular">{{
                  t('app.register.to.race.confirmation.payment.model', {
                    payeeModel:
                      registerToRaceResponse?.bankTransferInfo?.barcodePaymentDTO?.payeeModel ?? ''
                  })
                }} </p>
            </div>
          }
          @if (event?.paymentSettings?.paymentType?.includes(EventPaymentType.ONLINE_PAYMENT) &&
          !registrationWithoutPayment) {
            <div>
              <p class="medium pb-3 text-uppercase">{{
                  t('app.register.to.race.confirmation.payment.options')
                }} </p>
              <div class="d-flex justify-content-end align-items-center">
                <div class="pe-3">
                  <ng-container *ngTemplateOutlet="closeButton"></ng-container>
                </div>
                <app-button-alt [text]="t('app.register.to.race.pay.with.card')" [buttonColor]="'var(--teal-500)'"
                                [textColor]="'white'" [borderColor]="'var(--teal-500)'"
                                (onClickCallback)="onContinueWithPayment()"/>
              </div>
            </div>
          }
          @if (event?.paymentSettings?.mandatoryPayment !== true &&
          event?.paymentSettings?.paymentType?.includes(EventPaymentType.PAYMENT_BY_BANK_TRANSFER)
          && !registrationWithoutPayment && event?.paymentSettings?.createBarcode &&
          registerToRaceResponse?.bankTransferInfo?.barcode) {
            <div class="d-flex flex-column pt-3">
              <p class="medium">{{
                  t('app.register.to.race.confirmation.use.code.for.online.banking')
                }} </p>
              <img src="data:image/png;base64,{{registerToRaceResponse!.bankTransferInfo!.barcode}}" alt="barcode"
                   class="pt-4 img-fluid"/>
            </div>
          }
        }
      </app-section-card>
    </div>
  </ng-template>

  <ng-template #paymentStatus>
    <app-section-card [title]="t('app.register.to.race.payment.summary')" [enableToggle]="false">
      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.SUCCESS) {
        <div class="pb-3">
          <p class="regular">{{
              t('app.register.to.race.payment.well.done', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }} </p>
          <h1>{{
              t('app.register.to.race.confirmation.you.are.now.registered')
            }} </h1>
          <p class="py-3 medium">{{t('app.register.to.race.payment.success.title')}}</p>
          <div class="pb-3">
            <p class="regular">
              {{t('app.register.to.race.payment.success.desc')}} </p>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <app-button-alt [text]="t('app.register.to.race.close')" [borderColor]="'var(--teal-500)'"
                            [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onClose()"
                            [buttonColor]="'transparent'"/>
          </div>
        </div>
      }

      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.ERROR) {
        <div class="pb-3">
          <p class="regular">
            {{
              t('app.register.to.race.payment.ups', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }} </p>
        </div>

        <p class="py-3 medium">{{t('app.register.to.race.payment.error.title')}}</p>
        <div class="pb-3">
          <p class="regular">
            {{t('app.register.to.race.payment.error.desc')}} </p>
        </div>
        <div class="d-flex justify-content-end align-items-center">
          <app-button-alt [text]="t('app.register.to.race.close')" [borderColor]="'var(--teal-500)'"
                          [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onClose()"
                          [buttonColor]="'transparent'"/>
        </div>
      }

      @if (wspayConfirmation?.paymentStatus === WsPaymentStatus.CANCEL) {
        <div class="pb-3">
          <p class="regular">
            {{
              t('app.register.to.race.payment.dear', {
                name:
                  ((wspayConfirmation?.competitors?.length ?? 0) > 0 ?
                    (wspayConfirmation!.competitors![0].firstName ?? '') : '')
              })
            }} </p>
        </div>

        <div class="py-3 medium">{{t('app.register.to.race.payment.canceled.title')}}</div>
        <div class="pb-16">
          <p class="regular">{{t('app.register.to.race.payment.canceled.desc')}} </p>
          <div class="d-flex justify-content-end align-items-center">
            <app-button-alt [text]="t('app.register.to.race.close')" [borderColor]="'var(--teal-500)'"
                            [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onClose()"
                            [buttonColor]="'transparent'"/>
          </div>
        </div>
      }
    </app-section-card>
  </ng-template>

  <ng-template #summary>
    <div class="col-12 col-xxl-6 increase-column-left-spacing" [class.pt-48-38]="isSmallerThanXXL"
         [class.pt-32]="!authenticationService.isAuthenticated() && !isSmallerThanXXL">
      <app-section-card [title]="t('app.register.to.race.summary')" [enableToggle]="false"
                        [cssClass]="'sticky-sidebar-lg'">
        <div class="h-100">
          <form [formGroup]="inputForm">
            <ng-container formArrayName="coupons">
              @for (competitorRegistrationSummaryItem of getSummaryCompetitorItems(); track $index) {
                @if ($index > 0) {
                  <div class="horizontal-separator"></div>
                  <div>&nbsp;</div>
                }
                <p class="medium text-uppercase">{{ t('app.register.to.race.participant') }}:<p
                  class="large text-uppercase">{{
                    (competitorRegistrationSummaryItem.firstName ?? '') + ' ' +
                    (competitorRegistrationSummaryItem.lastName ?? '')
                  }}</p><!-- registration fee output-->

                @if (competitorRegistrationSummaryItem.raceCommercialItem &&
                competitorRegistrationSummaryItem.raceCommercialItem.price !== undefined) {
                  <!-- In case that race is free, there
                                   is no kotization
                                   --->
                  <div>
                  @if (!registerHelper?.isTeamRegistration() || $index === 0) {
                    @if (registerToRaceFormType === RegisterToRaceFormType.PAYMENT) {
                      <app-register-to-race-fee-item-output [race]="race" [defaultLanguage]="event?.defaultLanguage"
                                                            [eventCurrencyLabel]="eventCurrencyLabel"
                                                            [competitorRegistrationSummaryItem]="competitorRegistrationSummaryItem"
                                                            [languages]="languages"/>
                    } @else {
                      <app-register-to-race-fee-item-output [race]="race" [defaultLanguage]="event?.defaultLanguage"
                                                            [eventCurrencyLabel]="eventCurrencyLabel"
                                                            [raceCommercialItems]="raceCommercialItems"
                                                            [competitorRegistrationSummaryItem]="competitorRegistrationSummaryItem"
                                                            [languages]="languages"/>
                    }
                  }
                  </div>
                }
                @for (item of competitorRegistrationSummaryItem.raceAdditionalPricingItems;track $index) {
                  <!-- selected registration additional pricing items-->
                  <p class="regular">
                    <app-register-to-race-additional-item-output [defaultLanguage]="event?.defaultLanguage"
                                                                 [eventCurrencyLabel]="eventCurrencyLabel"
                                                                 [raceAdditionalPricingItem]="item"
                                                                 [languages]="languages"/>
                  </p>
                }
                @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO
                && competitorRegistrationSummaryItem.raceCommercialItem &&
                competitorRegistrationSummaryItem.raceCommercialItem.price !== 0) {
                  @if (!registerHelper?.isTeamRegistration()) {
                    <ng-container [formGroupName]="$index">
                      <div class="py-3">
                        <div class="d-flex align-items-start">
                          <app-input formControlName="coupon" [formId]="'coupon'+$index"
                                     [placeholder]="t('app.register.to.race.coupon')" borderRadiusTopRight="0"
                                     borderRadiusBottomRight="0" [backgroundColor]="'var(--teal-50)'"
                                     [borderColor]="'var(--teal-50)'"/>
                          <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                          [text]="t('app.register.to.race.apply')" [borderColor]="'var(--teal-500)'"
                                          (onClickCallback)="onApplyCoupon($index, coupons.at($index).value.coupon)"
                                          [isDisabled]="isApplyCouponButtonDisabled($index, coupons.at($index).value.coupon)"
                                          [borderRadiusTopLeft]="'0'" [borderRadiusBottomLeft]="'0'"
                                          [buttonHeight]="'var(--input-height)'"></app-button-alt>
                        </div>
                      </div>
                    </ng-container>
                  }
                }
              }
            </ng-container>


            @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO && ((raceCommercialItems?.length
              ?? 0) > 0) && registerHelper?.isTeamRegistration()) {
              <!-- Enter and apply coupon for team registration -->
              <div class="horizontal-separator"></div>
              <div class="d-flex align-items-start py-3">
                <app-input formControlName="teamCoupon" [placeholder]="t('app.register.to.race.coupon')"
                           [borderRadiusTopRight]="isAfterViewInitPassed ? '0' : undefined"
                           [borderRadiusBottomRight]="isAfterViewInitPassed ? '0' : undefined"
                           [backgroundColor]="'var(--teal-50)'" [borderColor]="'var(--teal-50)'"/>
                @if (isAfterViewInitPassed) {
                  <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'"
                                  [text]="t('app.register.to.race.apply')" [borderColor]="'var(--teal-500)'"
                                  (onClickCallback)="onApplyTeamCoupon()"
                                  [isDisabled]="isApplyTeamCouponButtonDisabled()" [borderRadiusTopLeft]="'0'"
                                  [borderRadiusBottomLeft]="'0'"></app-button-alt>
                }
              </div>
            }

            @if (registerToRaceFormType === RegisterToRaceFormType.CONFIRMATION || registerToRaceFormType
            === RegisterToRaceFormType.PAYMENT) {
              <div class="d-flex justify-content-start align-items-center">
                <div class="d-flex flex-column">
                  <p class="regular">{{t("event.item.start.date")}}
                    {{
                      event?.start
                        ? (event!.start! | date: 'dd.MM.yyyy': undefined: translocoService.getActiveLang())
                        : ''
                    }}
                </div>
                <div class="vertical-separator"></div>
                <div class="d-flex flex-column">
                  <p class="regular">{{t("event.item.start.time")}}
                    {{event?.start ? (event!.start! | localizedDate:'HH:mm') : ''}} </p>
                </div>
              </div>
            }
          </form>
          @if (registerToRaceFormType ===
          RegisterToRaceFormType.PAYMENT || ((raceCommercialItems?.length ?? 0) > 0
            && (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO || getTotalPrice() !== 0))) {
            <div class="d-flex flex-row justify-content-between pb-2">
              <p class="regular">{{t('app.register.to.race.subtotal')}}:</p>
              <p class="regular">{{getSubTotalPrice() | myCurrency:eventCurrencyLabel}}</p>
            </div>
            <div class="d-flex flex-row justify-content-between pb-2">
              <p class="regular">{{t('app.register.to.race.discount')}}:</p>
              <p class="regular">{{getSubTotalPrice() - getTotalPrice() | myCurrency:eventCurrencyLabel}}</p>
            </div>
            <div class="horizontal-separator"></div>
            <div class="d-flex flex-row justify-content-between pt-2">
              <p class="large text-uppercase">{{t('app.register.to.race.total.price')}}:</p>
              <p class="regular">{{getTotalPrice() | myCurrency:eventCurrencyLabel}}</p>
            </div>
          }
        </div>
      </app-section-card>
      @if (registerToRaceFormType === RegisterToRaceFormType.REGISTRATION_INFO) {
        <div class="d-flex d-xxl-none">
          <ng-container *ngTemplateOutlet="racerButtonsTemplate"></ng-container>
        </div>
      }
    </div>
  </ng-template>

  <ng-template #racerButtonsTemplate>
    <div class="w-100 pt-4">
      <div class="d-flex flex-column flex-md-row align-items-center justify-content-end">
        @if (isAddNewRacerButtonVisible()) {
          <div class="pe-0 pe-md-3 mb-3 mb-md-0" [class.w-100]="isSmallerThanXXL">
            <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [borderColor]="'var(--teal-500)'"
                            [text]="t('app.register.to.race.add.another.racer')" (onClickCallback)="addNewRacer()"
                            [isFullWidth]="isSmallerThanXXL"></app-button-alt>
          </div>
        }
        <app-button-alt [buttonColor]="'var(--teal-500)'" [textColor]="'white'" [borderColor]="'var(--teal-500)'"
                        [text]="t('app.register.to.race.confirm.registration') "
                        (onClickCallback)="confirmRegistration()"
                        [isFullWidth]="isSmallerThanXXL"></app-button-alt>
      </div>
    </div>
  </ng-template>

  <ng-template #closeButton>
    <app-button-alt [text]="t('app.common.close')" [borderColor]="'var(--teal-500)'"
                    [textColor]="'var(--grey-neutral-800)'" (onClickCallback)="onClose()"
                    [buttonColor]="'transparent'"></app-button-alt>
  </ng-template>

</ng-container>


